<ng-container  *ifLdFeature="featureFlag.EnableDisplayCustomFieldsNova">  
        <mat-card class="cf-mat-card" *ngIf="wrapWithCard; else customFields">
            <ng-container *ngTemplateOutlet="customFields">
            </ng-container>
        </mat-card>
    
        <ng-template #customFields>           
            <div>
                <h3>Custom Fields</h3>
                <nova-custom-field-grid-viewer-table [values]="values$ | async" [isLoading]="isLoading">
                </nova-custom-field-grid-viewer-table>             
                <div *ngIf="isLoading" class="cf-table-spinner">
                    <mat-progress-spinner
                        color="primary"
                        mode="indeterminate"
                        diameter="30" class="self-center">
                    </mat-progress-spinner>
                </div>
            </div>
        </ng-template>    
</ng-container>
